import { gql } from '@apollo/client';

export const createCourse = gql`
  mutation createCourse($input: CreateCourseInput!) {
    createCourse(input: $input) {
      id
      shortId
      domains {
        name
      }
      name {
        value
        languageCode
      }
      createdAt
      categories {
        id
        name {
          value
          languageCode
        }
      }
      experts {
        id
        firstName
        lastName
      }
      type
      status
      archivedScheduledAt
      archiveDate
      publishedAt
      catalogs {
        id
        name {
          value
          languageCode
        }
      }
    }
  }
`;
